<template>
  <div
    class="preview-card row"
    :class="{ asLink: $listeners.click }"
    role="article"
    tabindex="0"
  >
    <div class="image col-xs-12 col-md-4" :class="{ block: !isQuestion }">
      <div class="content" :class="{ circle: circle }">
        <div class="preview-card__favourite" v-if="showFavourite">
          <icon
            width="16"
            height="16"
            name="star"
            :class="{ favourite: isFavourite }"
            @click="toggleFavourite"
            :color="fillColour"
          ></icon>
        </div>
        <img
          src="https://www.gravatar.com/avatar/sdfdsfdsfdsfsd?f=y&d=mp"
          v-if="isQuestion"
        />
        <div
          class="date-holder-lg"
          v-else-if="!default_image && contentType == 'event'"
        >
          <time>
            <span>{{ $dayjs(dateString).format("D") }}</span>
            <span>{{ $dayjs(dateString).format("MMM") }}</span>
          </time>
        </div>
        <image-loader
          :image="default_image"
          :alt="title"
          v-else
          @click.native="handleClick"
          @keyup.enter="handleClick"
        />
      </div>
    </div>
    <div class="content col-xs-12 col-md-8">
      <h2>
        <router-link
          to="/"
          @click.native="handleClick"
          @keyup.enter="handleClick"
          >{{ title }}</router-link
        >
      </h2>
      <p v-if="contentType == 'content'" class="content-meta">
        <icon name="book-open" class="icon" color="#768692" />
        {{ dateString }}
      </p>
      <date-with-icon
        v-else
        :date="dateString"
        :showIcon="true"
        :icon="iconToShow"
      ></date-with-icon>
    </div>
  </div>
</template>

<script>
import { Date as DateWithIcon, ImageLoader } from "@/components/elements";
import MetaRow from "@/components/MetaRow";
export default {
  methods: {
    handleClick() {
      //are we a web url?
      if (this.website_url) {
        window.open(this.website_url);
        return;
      }
      // TODO: Do we need to return all the props that have been passed?
      this.$emit("click", this.id);
    },
    toggleFavourite() {
      this.$emit("onFavourite");
    },
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    default_image: {
      type: Object,
      default: () => {},
    },
    date: [String, Date, Number],
    start_date: [String, Date, Number],
    created_time: {
      type: [String, Date],
      default: () => new Date(),
    },
    self: String,
    id: Number,
    dateIcon: {
      type: String,
      default: "clock",
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Object,
      default: () => {},
    },
    isQuestion: {
      type: Boolean,
      default: false,
    },
    parent_data: [Array, Object],
    website_posted_date: {
      type: [String, Date, Number],
      default: () => new Date(),
    },
    website_url: String,
    isFavourite: {
      type: Boolean,
      default: false,
    },
    showFavourite: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fillColour() {
      return this.isFavourite ? "#005eb8" : "#425563";
    },
    dateString() {
      if (this.contentType == "content") {
        if (this.parent_data.title) {
          return this.parent_data.title;
        }
        return "Page";
      } else if (this.contentType == "event") {
        return this.start_date;
      } else {
        return this.website_posted_date
          ? this.website_posted_date
          : this.created_time;
      }
    },
    contentType() {
      if (!this.self) {
        return "news";
      }
      const urlBits = this.self.split("/");
      if (urlBits.includes("content") || urlBits.includes("forms")) {
        return "content";
      } else if (urlBits.includes("event")) {
        return "event";
      } else {
        return "news";
      }
    },
    iconToShow() {
      if (this.contentType == "content") {
        return "book-open";
      } else if (this.contentType == "event") {
        return "calendar";
      } else {
        return "clock";
      }
    },
  },
  components: {
    DateWithIcon,
    ImageLoader,
    MetaRow,
  },
};
</script>

<style scoped lang="scss">
.preview-card {
  display: flex;
  width: 100%;
  margin: 0 0 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid $colour-nhs-pale-grey;
  flex-direction: row;

  &.asLink {
    cursor: pointer;
    transition: all ease 0.3s;
    &:hover {
      h3 {
        color: $colour-nhs-core-blue;
      }
    }
  }

  .image {
    position: relative;
    max-width: 100%;
    margin-bottom: 1em;
    @media (min-width: 768px) {
      max-width: 100px;
      margin-bottom: 0;
    }

    &.block {
      &:after {
        @media (min-width: 768px) {
          content: "";
          display: block;
          padding-bottom: 100%;
        }
      }
    }

    .content {
      max-width: 100%;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      width: 100%;
      height: 100%;
      max-height: 127px;
      display: flex;
      @media (min-width: 768px) {
        position: absolute;
        text-align: right;
        max-width: 90px;
        max-height: 90px;
      }

      &.circle {
        border-radius: 100%;
        max-width: 75px;
        max-height: 75px;
      }
      img {
        width: 100%;
        max-width: 100%;
        display: inline-flex;
        align-self: center;
        @media (min-width: 768px) {
          width: auto;
          height: 100%;
          max-width: none;
          margin: 0 auto;
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          @supports (object-fit: cover) {
            min-height: 75px;
            width: 100%;
            min-width: 75px;
            height: 100%;
            object-fit: cover;
            max-width: 90px;
            max-height: 90px;
            position: relative;
            transform: none;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

  .content {
    h2 {
      font-size: 1.17em;
      padding-top: 0;
      margin-top: 0;
      font-family: $font-frutiger-light;
      color: $colour-nhs-black;
    }
  }

  a {
    text-decoration: none;
    color: $colour-nhs-black;

    &:hover {
      color: $colour-nhs-core-blue;
    }
  }

  &__favourite {
    align-items: center;
    background: $colour-nhs-core-white;
    border-radius: 100%;
    display: flex;
    left: 5px;
    padding: 3px;
    position: absolute;
    top: 5px;
    z-index: 5;
  }
}

.date-holder-lg {
  background: #e8edee;
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px 0;

  time {
    align-self: center;
  }
  span {
    &:first-of-type {
      font-size: 30px;
    }
    display: block;
    width: 100%;
    color: #425563;
    font-size: 16px;
  }
}

.content-meta {
  display: inline-flex;
  align-items: center;
  line-height: 0.875rem;
  margin: 0;
  padding: 0;
  font-weight: normal;
  font-size: 14px;
  color: $colour-nhs-mid-grey;
  .icon {
    margin-right: 5px;
    fill: $colour-nhs-mid-grey;
  }
}
</style>
